//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 左侧分享列表
 * @author blake
 */
import { getQueryValue, getDomain } from "@/utils/index";
import { Popover } from "apower-ui";

const links = {
  google: {
    url: "https://plus.google.com/share?url={url}&t={title}",
    width: 500,
    height: 500,
  },

  facebook: {
    url: "http://www.facebook.com/sharer/sharer.php?u={url}&title={title}",
    width: 673,
    height: 374,
  },

  twitter: {
    url: "https://twitter.com/intent/tweet?url={url}&text={title}",
    width: 548,
    height: 430,
    text: "Share",
  },

  pinterest: {
    url: "//assets.pinterest.com/js/pinmarklet.js",
    append: true,
    width: 600,
    height: 400,
  },

  hatena: {
    url: "http://b.hatena.ne.jp/entry/panel/?url={url}&btitle={title}",
    width: 365,
    height: 220,
  },

  linkedin: {
    url:
      "https://www.linkedin.com/shareArticle?mini=true&url={url}&title={title}",
    width: 600,
    height: 600,
  },

  linkedinja: {
    img: "https://qncdncss.aoscdn.com/img/phone-mirror/linkedin-jp.png",
    popover: true,
  },

  weixin: {
    img: "/do.php?action=qrcode&data={url}&size=5",
    popover: true,
  },

  douban: {
    url:
      "http://www.douban.com/share/service?href={url}&name={title}&text={text}",
  },

  qzone: {
    url:
      "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&title={title}&desc={text}&summary=&site=",
  },

  weibo: {
    url:
      "http://service.weibo.com/share/share.php?url={url}&title={title}&searchPic=true",
  },

  tencent: {
    url:
      "http://share.v.t.qq.com/index.php?c=share&a=index&url={url}&title={title}",
  },

  youdao: {
    url: "http://note.youdao.com/memory/?url={url}&title={title}",
  },
};

export default {
  name: "ShareVertical",
  componentName: "ShareVertical",
  components: {
    Popover,
  },
  props: {
    // 自定义分享列表内容和顺序(weixin始终排在第一位，无法调整顺序）
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 是否展示微信二维码
    showWeixin: {
      type: Boolean,
      default: true,
    },
    // 自定义微信二维码地址
    wxUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      lang: "en",
      isCollapsed: false,
      onopenparams: null,
      qrcodeUrl: "", // 微信二维码链接
      shareUrl: "",
    };
  },
  computed: {
    listData() {
      if (this.items && this.items.length > 0) {
        return this.items;
      }

      if (this.lang === "zh") {
        if (this.showWeixin) {
          return ["weixin", "douban", "qzone", "weibo", "tencent", "youdao"];
        } else {
          return ["douban", "qzone", "weibo", "tencent", "youdao"];
        }
      }

      if (this.lang === "ja") {
        return ["google", "twitter", "linkedinja", "facebook", "hatena"];
      }

      return ["google", "facebook", "twitter", "pinterest", "linkedin"];
    },
    shareListObj() {
      const temp = [];
      this.listData.forEach((item) => {
        links[item] && temp.push(Object.assign(links[item], { name: item }));
      });
      return temp;
    },
    showPopover() {
      return (
        this.listData.indexOf("weixin") !== -1 ||
        this.listData.indexOf("linkedinja") !== -1
      );
    },
  },
  created() {
    const lang = getQueryValue("lang") || document.documentElement.lang || "en";
    this.lang = lang;
  },
  mounted() {
    if (this.listData.indexOf("weixin") !== -1) {
      this.qrcodeUrl = this.getQrcodeUrl("weixin");
    }
    if (this.listData.indexOf("linkedinja") !== -1) {
      this.qrcodeUrl = this.getQrcodeUrl("linkedinja");
    }
  },
  methods: {
    collapseShareList() {
      this.isCollapsed = !this.isCollapsed;
    },
    getQrcodeUrl(name) {
      return this.openLink(name);
    },
    openLink(name) {
      const title = document.documentElement.title || "";
      const text = "";
      const url = this.shareUrl || location.href;
      const link = this.getShareLink(name, url, title, text);

      if (name === "weixin" || name === "linkedinja") {
        return link;
      }

      if (links[name].append) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = link;
        document.getElementsByTagName("head")[0].appendChild(script);
      }
      if (!links[name].append && links[name].url) {
        const width = links[name].width;
        const height = links[name].height;
        let params = "";

        if (width && height) {
          params = "width=" + width + ",height=" + height;
        }

        if (this.onopenparams) {
          params = this.onopenparams(params, name);
        }
        window.open(link, "share-to-" + name, params);
      }
    },

    getShareLink(name, url, title, text) {
      let link = links[name].url || links[name].img;

      if (name === "weixin") {
        link = getDomain("zh") + link;
        url = this.wxUrl ? this.wxUrl : url;
      }

      if (name === "linkedinja") {
        if (link.indexOf("http") !== 0) {
          link = getDomain("ja") + link;
          return link;
        }
      }

      const o = {
        url: encodeURIComponent(url),
        title: encodeURIComponent(title),
        text: encodeURIComponent(text),
      };

      link = this.stringFormat(link, o);

      return link;
    },

    stringFormat(str, json, forceReplace = false) {
      let o;
      if (json instanceof Object) {
        o = json;
      } else {
        o = Array.from(arguments);

        if (typeof o[o.length - 1] === "boolean") {
          forceReplace = o.pop();
        }
      }

      return str.replace(/\{(\w+)\}/g, function (m0, m1) {
        var v = o[m1];

        if (v === undefined || v === null) {
          v = forceReplace ? "" : m0;
        }

        return String(v);
      });
    },
  },
};
